import React from 'react'
import './Nav.scss'

export const Nav = () => (
  <nav className="navbar navbar-default navbar-custom navbar-fixed-top">
    <div className="container-fluid">
      <div className="navbar-header page-scroll">
        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
        </button>
        <a className="navbar-brand" href="/">Home</a>
      </div>
      <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
        <ul className="nav navbar-nav navbar-right">
          <li>
            <a href="/about">About</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
)

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js